<template>
    <div class="mt-4">
        <template v-if="downloads">
            <template v-if="!!downloads.length">
                <b-alert show variant="warning">
                    <h4 class="alert-heading">{{ $t('my_downloads.downloads_in_progress') }}</h4>
                    <p>{{ $t('my_downloads.downloads_text') }}</p>
                </b-alert>

                <div class="text-right my-4">
                    <b-dropdown variant="light" :text="$t('my_downloads.download')" right>
                        <b-dropdown-item v-if="itemIds.length > 0 && itemIds.length < items.length" to="#"
                                         @click.prevent="handleMultiDownload">{{
                            $t('my_downloads.selected_photos') }}
                        </b-dropdown-item>
                        <b-dropdown-item to="#" @click.prevent="handleMultiDownload('all')">{{ $t('my_downloads.all_photos') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th class="border-top-0" width="40">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="img-all" v-model="allItems">
                                    <label class="custom-control-label" for="img-all"></label>
                                </div>
                            </th>
                            <th class="border-top-0 text-center" width="10%">{{ $t('my_downloads.image') }}</th>
                            <th class="border-top-0" width="30%">{{ $t('album') }}</th>
                            <th class="border-top-0">{{ $t('my_downloads.number') }}</th>
                            <th class="border-top-0">{{ $t('my_downloads.downloads') }}</th>
                            <th class="border-top-0">{{ $t('my_downloads.expire_date') }}</th>
                            <th class="border-top-0 text-center" width="7%">{{ $t('my_downloads.action') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in items" :key="i" :class="{disabled: item.disabled}">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="`img-${i}`"
                                           v-model="item.selected" :disabled="item.disabled" @change="handleSelect">
                                    <label class="custom-control-label" :for="`img-${i}`"></label>
                                </div>
                            </td>
                            <td>
                                <div class="tmb" :style="{backgroundImage: `url(${item.order_image && item.order_image.thumb_photo ? item.order_image.thumb_photo : ''})`}"></div>
                            </td>
                            <td>
                                <strong>{{ item.album_name }}</strong><br>
                                <small>{{ item.product_name }} - {{ item.variant_name }}</small>
                            </td>
                            <td>{{ item.file_name }}</td>
                            <td>{{ item.download_counter }}</td>
                            <td>{{ item.download_expiry | moment('DD.MM.YYYY HH:mm') }}</td>
                            <td class="text-center">
                                <a href="#" v-if="item.disabled" class="btn btn-warning disabled" @click.prevent=""
                                   :title="$t('my_downloads.downloads_in_progress')">
                                    <span class="material-icon icon-autorenew"></span>
                                </a>
                                <a href="#" v-else class="btn btn-primary" @click.prevent="handleDownload(i)"
                                   :title="$t('my_downloads.download_picture')">
                                    <span class="material-icon icon-cloud_download"></span>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <div v-else class="alert alert-info">{{ $t('no_data') }}</div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    @keyframes ants {
        to {
            background-position: 100% 100%
        }
    }

    .tmb {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 120px;
        background: #f1f1f1 50% 50% no-repeat;
        background-size: contain;
    }

    tr.disabled {
        opacity: .5;
    }
</style>

<script>
  import downloads from 'src/mixins/downloadsComponent';

  export default {
    mixins: [downloads],
  };
</script>
